import * as types from 'actions';

export const initialState={
  address: '',  
  longitude: '',
  latitude: ''
}

export default function(state = initialState, action) {
  const places = action.places;

  switch(action.type) {
    case types.PLACES_CHANGE:        
      return {
        ...state, 
        address : places.address, 
        longitude : places.longitude,
        latitude : places.latitude,
        places };
    default:
      return state;
  }
};